export const HAS_LOGGED_IN_KEY = 'gm_has_logged_in';
export const ATTRIBUTION_KEY = 'gm_attrib';
export const DEMO_SRC_KEY = 'gm_demo_src';
